/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react'

import { t } from '@/i18n'
import { ProposalNode } from '@/apollo/graphql'
import { editProposalPath, generatePath } from '@/utils'
import { FieldViewLink, OptionSelector } from '@/components'
import { Maybe } from '@/types'
import { useProposalSelect } from './useProposalSelect'

interface Props {
  isEditing?: boolean
  initial?: Maybe<Partial<ProposalNode>>
  selected?: string
  [x: string]: any
}

const ProposalSelector: React.FC<Props> = ({
  isEditing,
  initial,
  selected,
  ...rest
}) => {
  const { proposalOptions, loading, pageInfo, onFetchMore } = useProposalSelect(
    {
      initial,
    },
  )

  const selectedProposal = useMemo(() => {
    if (selected) {
      return proposalOptions.find(p => p.value === selected)
    }

    return null
  }, [proposalOptions, selected])

  const emptyValue = useMemo(() => (isEditing ? '' : '...'), [isEditing])

  if (!isEditing && selectedProposal) {
    return (
      <FieldViewLink
        label={t('proposal')}
        linkLabel={selectedProposal?.label}
        link={generatePath(editProposalPath, {
          id: selectedProposal?.value,
        })}
      />
    )
  }

  return (
    <OptionSelector
      {...rest}
      name="proposal"
      menuPlacement="top"
      options={proposalOptions}
      optionsLoading={loading}
      emptyValue={emptyValue}
      disabled={!Boolean(isEditing)}
      label={t('proposal')}
      fetchMoreStatus={pageInfo.fetchMoreStatus}
      onFetchMore={onFetchMore}
    />
  )
}

export default ProposalSelector
